/*
 * Copyright (c) 2020
 *    Reliant Business Valuation, LLC - http://www.reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SearchableProvider} from "../model/interface/searchable.provider";
import {RestResponse} from "../model";
import {environment} from "../../environments/environment";
import {ApiHeaders} from "./headers";
import {ReportNote} from "../model/report.note";

@Injectable()
export class ReportNotesProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) {
  }

  getNotes(id: string, page: number, query?: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/notes?page=${page}${query ? '&query=' + encodeURIComponent(query) : ''}`,
        ApiHeaders.getOptions());
  }

  createNote(id: string, note: ReportNote): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/notes`, note,
        ApiHeaders.getOptions());
  }

  updateNote(id: string, note: ReportNote): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/notes/${note.ID}`, note,
        ApiHeaders.getOptions());
  }

  deleteNote(id: string, noteId: string): Observable<RestResponse> {
    return this.http
      .delete<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/notes/${noteId}`,
        ApiHeaders.getOptions());
  }

  getSearchType(): string {
    return 'REPORT_NOTES';
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return undefined;
  }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number): Observable<RestResponse> {
    return this.getNotes(id, 1, query);
  }

  reorderNote(id: string, note: ReportNote, replaceNum: number): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/notes/reorder?order=${replaceNum}`, note,
        ApiHeaders.getOptions());
  }
}
